import { render } from "./LzButton.vue?vue&type=template&id=d0749944"
import script from "./LzButton.vue?vue&type=script&lang=js"
export * from "./LzButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__